import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import {
  isLegacyTicketsEnabled,
  TICKETS_V2_PATH,
} from "../../config/featureFlags";

/**
 * Keeps the legacy ticket section available only when explicitly enabled.
 */
export default function LegacyTicketsGuard({ children }) {
  const location = useLocation();

  if (!isLegacyTicketsEnabled) {
    return (
      <Navigate
        to={`${TICKETS_V2_PATH}${location.search}${location.hash}`}
        replace
      />
    );
  }

  return children;
}
